import * as types from './actionTypes';

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import API from '../constants/apiEndpoints';
import { beginAjaxCall } from './ajaxStatusActions';
import { constants } from '../constants/constants';
import { msalFetch } from '../components/auth/Auth-Utils';
import { ThunkResult } from '../models';
import { toastr } from 'react-redux-toastr';

/*
 * get the analytics data for the dashboard
 */
export function getDashboardAnalytics(
    buildingID?: string,
    floorID?: string,
    locationID?: string
): ThunkResult<any> {
    return (dispatch, getState) => {
        dispatch(beginAjaxCall());
        const { selectedFacilityID } = getState();
        if (selectedFacilityID.length === 0) {
            console.error('[getDashboardAnalytics]:', {
                selectedFacilityID,
                state: getState()
            });
            toastr.warning(
                'Warning',
                'Selected customer has 0 facilities.',
                constants.toastrWarning
            );
        }
        const axiosOptions: AxiosRequestConfig = {
            method: 'get',
            params: {
                facilityID: selectedFacilityID,
                buildingID: buildingID || undefined,
                floorID: floorID || undefined,
                locationID: locationID || undefined
            }
        };

        const url = API.update.dashboard;
        return msalFetch(url, axiosOptions)
            .then((data: AxiosResponse<any>) => {
                if (!data.data) {
                    throw new Error('missing data');
                } else {
                    dispatch({
                        type: types.GET_DASHBOARD_ANALYTICS_SUCCESS,
                        payload: data.data
                    });
                }
            })
            .catch((error: any) => {
                dispatch({
                    type: types.GET_DASHBOARD_ANALYTICS_FAILED,
                    error,
                    axiosOptions
                });
                constants.handleError(error, 'get dashboard analytics');
                console.error(error);
            });
    };
}

/*
 * get inspection status data for service grid
 */
export function getDashboardInspectionStatus(
    facilityID: string,
    buildingID?: string,
    floorID?: string,
    locationID?: string
): ThunkResult<any> {
    return dispatch => {
        dispatch(beginAjaxCall());

        const axiosOptions: AxiosRequestConfig = {
            method: 'get',
            params: {
                facilityID,
                buildingID: buildingID || undefined,
                floorID: floorID || undefined,
                locationID: locationID || undefined
            }
        };

        const url = API.update.dashboardInspectionStatus;
        return msalFetch(url, axiosOptions)
            .then((data: AxiosResponse<any>) => {
                if (!data.data) {
                    throw new Error('missing data');
                } else {
                    dispatch({
                        type: types.GET_DASHBOARD_INSPECTION_STATUS_SUCCESS,
                        payload: data.data
                    });
                }
            })
            .catch((error: any) => {
                dispatch({
                    type: types.GET_DASHBOARD_INSPECTION_STATUS_FAILED,
                    error,
                    axiosOptions
                });
                constants.handleError(error, 'get dashboard inspection status');
            });
    };
}

/*
 * get maintenance actions for service grid - the API returns trigger rows for assets
 * that have one and open SAP Service Plan work for the rest
 */
export function getDashboardMaintenanceActions(
    facilityID: string,
    buildingID?: string,
    floorID?: string,
    locationID?: string
): ThunkResult<any> {
    return dispatch => {
        dispatch(beginAjaxCall());

        const axiosOptions: AxiosRequestConfig = {
            method: 'get',
            params: {
                facilityID,
                buildingID: buildingID || undefined,
                floorID: floorID || undefined,
                locationID: locationID || undefined
            }
        };

        const url = API.GET.maintenanceTrigger.getMaintenanceActionsByFacility;
        return msalFetch(url, axiosOptions)
            .then((data: AxiosResponse<any>) => {
                if (!data.data) {
                    throw new Error('missing data');
                } else {
                    dispatch({
                        type: types.GET_DASHBOARD_MAINTENANCE_ACTIONS_SUCCESS,
                        payload: data.data
                    });
                }
            })
            .catch((error: any) => {
                dispatch({
                    type: types.GET_DASHBOARD_MAINTENANCE_ACTIONS_FAILED,
                    error,
                    axiosOptions
                });
                constants.handleError(
                    error,
                    'get dashboard maintenance actions'
                );
            });
    };
}

/*
 * get work history data for service grid
 */
export function getDashboardWorkHistory(facilityID: string, cutoffDate?: string): ThunkResult<any> {
    return dispatch => {
        dispatch(beginAjaxCall());

        const axiosOptions: AxiosRequestConfig = {
            method: 'get',
            params: {
                facilityID,
                ...(cutoffDate && { cutoffDate })
            }
        };

        const url = API.update.dashboardWorkHistory;
        return msalFetch(url, axiosOptions)
            .then((data: AxiosResponse<any>) => {
                if (!data.data) {
                    throw new Error('missing data');
                } else {
                    dispatch({
                        type: types.GET_DASHBOARD_WORK_HISTORY_SUCCESS,
                        payload: data.data
                    });
                }
            })
            .catch((error: any) => {
                dispatch({
                    type: types.GET_DASHBOARD_WORK_HISTORY_FAILED,
                    error,
                    axiosOptions
                });
                constants.handleError(error, 'get dashboard work history');
            });
    };
}
